export default __webpack_public_path__ + "static/media/rewards.1123661e.svg";